module.exports = __webpack_public_path__ + "img/hazardEquip15.14ab4767.jpg";